import React, { useState } from "react"
import Languages from "./languages"
import NavLinks from "./navlinks"

const NavBar = ({ menuLinks, locationName }) => {
  const [toggle, setToggle] = useState(false)

  const menuToggle = () => {
    const selectedElements = document.querySelectorAll(
      ".menu-btn__burger, .nav, .menu-nav, .menu-social-buttons, .menu-nav__item"
    )

    if (!toggle) {
      selectedElements.forEach(el => el.classList.add("open"))
    } else {
      selectedElements.forEach(el => el.classList.remove("open"))
    }
    setToggle(!toggle)
  }

  return (
    <>
      <button className="menu-btn" onClick={menuToggle}>
        <span className="menu-btn__burger"></span>
      </button>
      <nav className="nav">
        <ul className="menu-nav">
          <NavLinks
            menuLinks={menuLinks}
            closeMenu={menuToggle}
            locationName={locationName}
          />
        </ul>
        <Languages />
      </nav>
    </>
  )
}

export default NavBar
